import React, { useState, useEffect } from 'react';
import '../../../../assets/css/customer/publicCustomerCss/service.css';
import ServicesBlock from '../../../../components/customer/PublicCustomerScreens/MyServices/ServicesBlock';

const Services = () => {
    const servicesData = [
        { 
            icon: 'fas fa-mountain', 
            title: 'NORTH', 
            description: 'Explore majestic northern landscapes with expert guides and adventure packages' 
        },
        { 
            icon: 'fas fa-hotel', 
            title: 'HOTELS', 
            description: 'Luxury accommodations with premium amenities at competitive prices' 
        },
        { 
            icon: 'fas fa-utensils', 
            title: 'FOOD',
            description: 'Delicious local cuisine and fine dining experiences at recommended restaurants' // Updated description
        },
        { 
            icon: 'fas fa-calendar-check', 
            title: 'EVENTS', 
            description: 'Explore and discover cultural events, festivals across northern Pakistan.'

        },
        { 
            icon: 'fas fa-robot', 
            title: 'AI PLANNER', 
            description: 'Intelligent itinerary planning powered by artificial intelligence' 
        },
        { 
            icon: 'fas fa-map-marked-alt', 
            title: 'TRAVEL GUIDE', 
            description: 'Comprehensive travel guidance for destination' 
        }
    ];
    
    useEffect(() => {
        const blocks = document.querySelectorAll('.pub-serv-service-block');
        let currentBlock = 0;
        
        const demoHoverEffect = () => {
            blocks.forEach(block => {
                block.style.transform = '';
                block.style.animation = '';
            });
            
            if (currentBlock < blocks.length) {
                blocks[currentBlock].style.transform = 'scale(1.08)';
            }
            
            currentBlock = (currentBlock + 1) % blocks.length;
            setTimeout(demoHoverEffect, 2000);
        };
        
        const timer = setTimeout(demoHoverEffect, 3000);
        
        return () => clearTimeout(timer);
    }, []);
    
    const topRowServices = servicesData.slice(0, 3);
    const bottomRowServices = servicesData.slice(3, 6);
    
    return (
        <div className="pub-serv-services-app">
            <section className="pub-serv-services-section">
                <div className="pub-serv-section-title">
                    <h2>OUR TRAVEL SERVICES</h2>
                    <p>Premium travel solutions with cutting-edge technology and personalized experience</p>
                </div>
                
                <div className="pub-serv-services-container">
                    <div className="pub-serv-services-row">
                        {topRowServices.map((service, index) => (
                            <ServicesBlock
                                key={index}
                                service={service}
                                index={index}
                            />
                        ))}
                    </div>
                    
                    <div className="pub-serv-services-row">
                        {bottomRowServices.map((service, index) => (
                            <ServicesBlock 
                                key={index + 3}
                                service={service}
                                index={index + 3}
                            />
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Services;